var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#users_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 7C5.346 7 4 5.654 4 4V3c0-1.654 1.346-3 3-3s3 1.346 3 3v1c0 1.654-1.346 3-3 3m1 6.5v-1c0-1.222.881-2.242 2.042-2.458a2.5 2.5 0 0 1 .755-1.36c-2.738-.982-5.878-.865-8.509.365a.5.5 0 0 0-.252.268l-2 5a.5.5 0 0 0 .229.626c.081.043 2.039 1.06 6.735 1.06a27 27 0 0 0 2.726-.13A2.5 2.5 0 0 1 8 13.5m6-1.5h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H14v1.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V14h-1.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H12v-1.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "users_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgUsers;